var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSettingsClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8732_6807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.764167 11.2158L0.0991669 10.6325L0.682501 9.62333L1.52833 9.90917C1.715 9.75167 1.925 9.62917 2.15833 9.54167L2.33333 8.66667H3.5L3.675 9.53583C3.90833 9.62333 4.11833 9.74583 4.305 9.90333L5.15083 9.6175L5.73417 10.6267L5.06917 11.21C5.11583 11.5017 5.11583 11.6533 5.06917 11.945L5.73417 12.5283L5.15083 13.5375L4.305 13.2517C4.11833 13.4092 3.90833 13.5317 3.675 13.6192L3.5 14.5H2.33333L2.15833 13.6308C1.925 13.5433 1.715 13.4208 1.52833 13.2633L0.682501 13.5492L0.0991669 12.54L0.764167 11.9567C0.7175 11.6592 0.7175 11.5075 0.764167 11.2158ZM2.91667 12.75C3.55833 12.75 4.08333 12.225 4.08333 11.5833C4.08333 10.9417 3.55833 10.4167 2.91667 10.4167C2.275 10.4167 1.75 10.9417 1.75 11.5833C1.75 12.225 2.275 12.75 2.91667 12.75ZM7.58333 4.58333V7.73917L6.20667 9.11583L5.6 8.07167L6.41667 7.26083V4.58333H7.58333ZM1.75 7.5C1.75 4.60083 4.10083 2.25 7 2.25C8.65083 2.25 10.1208 3.02 11.0833 4.21V2.83333H12.25V6.33333H8.75V5.16667H10.3483C9.6075 4.11083 8.3825 3.41667 7 3.41667C4.74833 3.41667 2.91667 5.24833 2.91667 7.5H1.75ZM7.665 11.5308C9.40917 11.245 10.7858 9.83917 11.0367 8.08333H12.215C11.9233 10.7083 9.70083 12.75 7 12.75H6.95917L7.665 11.5308Z",
    fill: "#0D496D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8732_6807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(-1 0 0 1 14 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSettingsClockIcon);
export default __webpack_public_path__ + "static/media/blue_settings_clock_icon.723e3fcc.svg";
export { ForwardRef as ReactComponent };